export const CustomerExcelHeader = [
  {
    header: "CUSTOMER CODE",
    key: "CUSTOMER CODE",
    width: 25,
  },
  {
    header: "CUSTOMER NAME",
    key: "CUSTOMER CODE",
  },
  {
    header: "OWNER CODE",
    key: "OWNER CODE",
  },
  {
    header: "RELATED CUSTOMER CODE",
    key: "RELATED CUSTOMER CODE",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
];

export const CustomerExcelName = "Customer List";
